import { LogEventTypes } from 'automation-ui-log-events/constants/LogEventConstants';
import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
export const FETCH_SKIPPED_ENROLLMENT_LIST_FIELD_POLICY = {
  keyArgs: ['flowId', 'isHybrid', 'objectFilter', 'startTimestamp', 'endTimestamp'],
  merge(existing, incoming) {
    if (!existing) {
      return incoming;
    }
    return Object.assign({}, incoming, {
      results: [...existing.results, ...incoming.results]
    });
  }
};
export const SKIPPED_ENROLLMENT_LIST_FIELDNAME = 'automation_ui_canvas_skippedEnrollmentsList';
export const FETCH_SKIPPED_ENROLLMENT_LIST = registerQuery({
  fieldName: SKIPPED_ENROLLMENT_LIST_FIELDNAME,
  args: ['flowId', 'isHybrid', 'objectFilter', 'startTimestamp', 'endTimestamp'],
  fetcher({
    flowId,
    isHybrid,
    startTimestamp,
    endTimestamp,
    objectFilter,
    offset
  }) {
    return http.post('automationapps/v1/history', {
      data: Object.assign({
        limit: 50,
        flowId,
        isHybrid,
        startTimestamp,
        offset,
        endTimestamp
      }, objectFilter, {
        eventTypes: [LogEventTypes.PRE_ENROLLMENT]
      })
    });
  }
});